import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Box, Flex,  Link, Text } from 'theme-ui'
import TransitionLink from "gatsby-plugin-transition-link";

const MyElement = () => {
  const data = useStaticQuery(graphql`
     query footerLinks {
        allDatoCmsFooterMenu {
            edges {
            node {
                selectMenuItems {
                    slug
                    title
                    seo {
                        title
                    }
                }
            }
            }
        }
        }
   `)
    
    const menuLinks = data.allDatoCmsFooterMenu.edges[0].node.selectMenuItems;

    return (

        <Flex
            sx={{
                flexDirection: ['column', 'row'],
                flexWrap:"wrap",
                paddingY: [4, 3, 4],
                paddingX: [2, 3, 4],
            }}>
            
            
                    
            {menuLinks.length ? (
                
                menuLinks.map((menuLink, index) => {
                        
                    
                    

                    return (
                         <TransitionLink aria-label={menuLink.seo.title} to={"/" + menuLink.slug+"/"} exit={{ length: 0.5, }} entry={{ length: 0.5,delay:0.1   }} key={index}>
                                <Text  variant="tiny">
                                    {menuLink.title}
                            </Text>
                            <Box
                                as="span"
                                className="slash"
                              marginLeft={['2px','5px', '10px']}
                              marginRight={['2px','5px','10px']}>/</Box> 
                                
                            </TransitionLink>
                        );
                         
                    
                })
                ) : (
                <>
                    
                </>
                )}
        </Flex>
        
  );
      

}

export default MyElement